<template>
<div class="news">
  <Nav></Nav>
  <div class="news-header flex-align-center flex-center flex-column-direction" >
    <img src="../assets/images/news/News_Center.png" alt="">
    <span class="news-title">新闻中心</span>
  </div>
  <div class="news-content container semibold-text">
    <ul class="flex-align-center flex-center news-tabs-title">
      <li 
        v-for="(item, index) in newsTitle" 
        :key="index" 
        @click="handleChangeTab(index, item)" 
        :class="index == activeIndex ? active :'news-tabs-item'">
        {{item}}
      </li>
    </ul>
    <el-row :gutter="18" class="news-box">
      <el-col class="news-item" 
        :xs="24" :sm="12" :md="8" :lg="8" :xl="8" 
        v-for="(news, index) in newsList" 
        :key="index">
        <!-- <router-link :to="{ path: '/detail', query: { id: news.id } }"> -->
          <el-skeleton :loading="loading" animated class="news-el-skeleton">
            <template slot="template">
              <el-skeleton-item variant="image" class="news-item-box" />
            </template>
            <template>
              <div class="news-item-box" @click="toDetail(news)">
                <img v-if="news.imgUrl" class="news-item-img" :src="news.imgUrl" alt="" />
                <div v-else class="news-item-img-placeholder flex-align-center flex-center">重要新闻</div>
                <div class="news-item-content">
                  <div class="news-item-title">{{news.title}}</div>
                  <p class="news-item-time">{{news.setTime}}</p>
                </div>
              </div>
            </template>
          </el-skeleton>
        <!-- </router-link> -->
      </el-col>
    </el-row>
    <div class="pagination flex-end">
      <el-pagination 
        @current-change="handleCurrentChange" 
        background 
        :page-size="queryParams.count" 
        layout="prev, pager, next" 
        :total="total" 
        v-show="total>0" 
        :page.sync="queryParams.pageNum" 
        :limit.sync="queryParams.count" 
        :current-page.sync="queryParams.pageNum">
      </el-pagination>
    </div>
  </div>
   <!-- 关于我们开始 -->
  <section class="aboutus-box" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
    <ul>
      <li class="aboutus-item">
        <p class="aboutus-title">CONTACT US</p>
        <div class="flex-align-center flex-center ">
          <p class="flex-align-center aboutus-phone">
            <img class="mr5 aboutus-img " src="../assets/images/icon-phone.png" alt="">
            <span class="about-text">15083301945</span>
          </p>
          <p class="flex-align-center">
            <img class="mr5 aboutus-img" src="../assets/images/icon-qq.png" alt="">
            <span class="about-text">1478887151</span>
          </p>
        </div>
      </li>
      <li class="aboutus-item">
        <p class="aboutus-title">LINK</p>
        <div class="flex-align-center flex-center ">
          <a href="https://www.rendercool.com/" rel="noopener noreferrer" class="about-text">www.rendercool.com</a>
        </div>
      </li>
      <li class="aboutus-item">
        <p class="aboutus-title">ADD</p>
        <div class="flex-align-center flex-center ">
          <p class="about-text">宁夏中卫市沙坡头区中卫工业园区云天中卫众创空间4楼</p>
        </div>
      </li>
    </ul>
    
  </section>
  <!-- 关于我们结束 -->

  <Position></Position>
  <footer class="flex-center">
    <div class="footer">
      Copyright © {{ year }} rendercool.com 备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">宁ICP备2023000159号-1</a><a href="sitemap.htm">网站地图</a>
    </div>
  </footer>
</div>
</template>

<script>
import Nav from '../components/Nav/index.vue'
import Position from '../components/Position/index.vue'
export default {
  name: "News",
  components: {
    Nav,
    Position
  },
  data() {
    return {
      year: new Date().getFullYear(),
      loading: true,
      newsList: [],
      total: 0,
      queryParams: {
        pageNum: 0,
        pageSize: 6,
        type: '',
        newsType: 1, //  0：动画  1：效果图
      },
      details: {
        title: '',
        created_at: '',
        content: ''
      },
      activeIndex: 0,
      active: 'news-tabs-item-active',
      newsTitle: [ '全部', '活动', '公告', '新闻', '更新', '技巧' ]
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      this.loading = true
      this.$axios.get('https://v.renderg.com/pub-api/news/list', { params: this.queryParams })
        .then(response => {
          console.log('response', response)
          if (response.data.code == 200) {
            this.newsList = response.data.rows
            this.total = response.data.total
          } else {
            this.$message.error('没有更多数据')
            this.newsList = []
            this.total = 0
          }
        })
        .catch(error => {
          console.error(error)
          this.$message.error('获取新闻列表失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCurrentChange(page) {
      this.queryParams.pageNum = page
      this.getNewsList()
    },
    handleChangeTab (index, item) {
      this.activeIndex = index
      index == 0 ? this.queryParams.type = '' : this.queryParams.type = item
      this.queryParams.pageNum = 1
      this.getNewsList()
    },
    toDetail(news) {
      let url = news.linkUrl
      window.open(url, '_blank')
    }
  }
}

</script>

<style lang="scss" scoped>
@import url('../style/news.scss');
</style>

<style lang="scss">
.pagination {
  .el-pagination.is-background .btn-next, 
  .el-pagination.is-background .btn-prev, 
  .el-pagination.is-background .el-pager li {
    background-color: #2B2B2B;
    color: #555555;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #09CCD8;
  }
}
</style>
